import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/outsourced/wallet/page.tsx");
